import FlagIcon from 'vue-flag-icon'

export default (Vue) => {
  Vue.use(FlagIcon)
}
